.planTitleReadOnly {
	font-size: 16px;
	margin-right: var(--jpo-common-base-spacing);
	max-width: 700px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	word-break: break-all;
}

.planTitleReadViewContainer {
	display: flex;
	font-size: 16px;
	line-height: 1.75;
	padding: 0 var(--jpo-common-base-spacing);
}

.planTitle {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.planTitleContainer {
	max-width: 175px;
	display: flex;
	align-items: center;

	& > * {
		/* The text in the subchildren overflows the container because of the flex layout. */
		/* min-width: 0; makes sure that any text in the subchildren do not overflow the container. */
		/* More details -> https://css-tricks.com/flexbox-truncated-text/ */
		/* This is same for all the media queries below */
		min-width: 0;
	}

	&.withScenarios {
		max-width: 100px;
	}

	&.isReadOnly {
		max-width: 120px;

		&.withScenarios {
			max-width: 70px;
		}
	}

	&.isReportMode {
		max-width: 315px;

		&.withScenarios {
			max-width: 160px;
		}
	}

	/* offsetting the default InlineEdit marginTop of 8px */
	& > form > div {
		margin-top: 0px;
	}
}

.skeletonContainer {
	width: 100px;
	/* min-height is required to have at least 32px high box for rendering plan title skeleton */
	min-height: 32px;
}

@media (min-width: 1280px) {
	.planTitleContainer {
		max-width: 240px;
		display: flex;
		align-items: center;

		& > * {
			min-width: 0;
		}

		&.withScenarios {
			max-width: 160px;
		}

		&.isReadOnly {
			max-width: 180px;

			&.withScenarios {
				max-width: 125px;
			}
		}

		&.isReportMode {
			max-width: 425px;

			&.withScenarios {
				max-width: 240px;
			}
		}
	}
}

@media (min-width: 1440px) {
	.planTitleContainer {
		max-width: 280px;
		display: flex;
		align-items: center;

		& > * {
			min-width: 0;
		}

		&.withScenarios {
			max-width: 195px;
		}

		&.isReadOnly {
			max-width: 215px;

			&.withScenarios {
				max-width: 155px;
			}
		}

		&.isReportMode {
			max-width: 490px;

			&.withScenarios {
				max-width: 280px;
			}
		}
	}
}

@media (min-width: 1536px) {
	.planTitleContainer {
		max-width: 305px;
		display: flex;
		align-items: center;

		& > * {
			min-width: 0;
		}

		&.withScenarios {
			max-width: 215px;
		}

		&.isReadOnly {
			max-width: 235px;

			&.withScenarios {
				max-width: 175px;
			}
		}

		&.isReportMode {
			max-width: 525px;

			&.withScenarios {
				max-width: 305px;
			}
		}
	}
}

@media (min-width: 1680px) {
	.planTitleContainer {
		max-width: 340px;
		display: flex;
		align-items: center;

		& > * {
			min-width: 0;
		}

		&.withScenarios {
			max-width: 245px;
		}

		&.isReadOnly {
			max-width: 270px;

			&.withScenarios {
				max-width: 205px;
			}
		}

		&.isReportMode {
			max-width: 580px;

			&.withScenarios {
				max-width: 350px;
			}
		}
	}
}

@media (min-width: 1920px) {
	.planTitleContainer {
		max-width: 400px;
		display: flex;
		align-items: center;

		& > * {
			min-width: 0;
		}

		&.withScenarios {
			max-width: 305px;
		}

		&.isReadOnly {
			max-width: 330px;

			&.withScenarios {
				max-width: 260px;
			}
		}

		&.isReportMode {
			max-width: 675px;

			&.withScenarios {
				max-width: 420px;
			}
		}
	}
}
